module.exports = __webpack_public_path__ + "static/media/FlagCl.71e1a56b.svg";